import React from 'react';
import classNames from 'classnames';
import Typography from '@material-ui/core/Typography';
import { makeStyles } from '@material-ui/core/styles';
import useSimpleHousehold from 'Hooks/useSimpleHousehold';

const useStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
  },
  button: {
    ...theme.typography.h2,
    fontWeight: 300,
    lineHeight: '1.5',
  },
  note: {
    paddingTop: theme.spacing(1),
  },
  noteTitle: {},
  noteText: {},
}));

function Escalated() {
  const classes = useStyles();
  const { householdResource } = useSimpleHousehold();

  if (!householdResource.relationship('escalate')) return null;

  return (
    <div className={classNames('section-panel', classes.root)}>
      {householdResource.attr('escalationType') !== 'notEscalated' ? (
        <>
          <div className={classes.note}>
            <Typography className={classes.noteTitle} variant="h5">
              {'Escalation Note:'}
            </Typography>
            <Typography className={classes.noteTitle} variant="h5">
              {householdResource.attr('escalationNote')}
            </Typography>
          </div>
        </>
      ) : null}
    </div>
  );
}

export default Escalated;
